var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrite = function SvgWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 5.558 14.442 2.8a1.028 1.028 0 0 0-1.467 0l-9.483 9.475c-.15.15-.259.35-.3.558l-.684 3.434a1.043 1.043 0 0 0 1.017 1.25c.067 0 .133 0 .208-.017l3.434-.683c.216-.042.408-.15.558-.3L17.2 7.042a1.041 1.041 0 0 0 0-1.475v-.009ZM6.875 15.592l-3.083.616.616-3.075 7.017-7.025 2.467 2.467-7.017 7.017Zm7.9-7.9-2.467-2.467L13.7 3.833 16.167 6.3l-1.392 1.392Z",
    fill: "current"
  })));
};
export default SvgWrite;